export default {
	purchrole: {
		wrapper: 'col-12',
		component: 'radio-input-group',
		label: 'What is your responsibility/influence on buying decisions?',
		newEntryReset: true,
		options: [
			'Responsible for purchase decisions',
			'Influence / recommend purchasing decisions',
			'No influence on buying decisions',
		],
	},
	purchpower: {
		wrapper: 'col-12',
		component: 'radio-input-group',
		label: 'What is your purchasing power?',
		newEntryReset: true,
		options: [
			'None',
			'$0 - $499',
			'$500 - $999',
			'$1,000 - $4,999',
			'$5,000 - $9,999',
			'$10,000 - $49,999',
			'$50,000 - $99,999',
			'$100,000 - $249,999',
			'$250,000+',
		],
	},
};
